<template>
  <section
    v-if="order"
    class="status-area"
  >  
    <h4>
      <v-chip
        color="success"
        outlined        
      >
        <strong class="mr-1">Tipo Pedido:</strong>
        <span>{{ order.type_solicitation.name }}</span>
      </v-chip>
    </h4>
    <h4>
      <v-chip
        class="ma-2"
        color="success"
        outlined    
        v-if="order.plate"    
      >
        <strong class="mr-1">Placa:</strong>
        <span v-if="order.plate">{{ order.plate }}</span>
        <span v-else>-</span>
      </v-chip>
    </h4>
    <h4 style="text-align: right;">
      <v-chip
        color="success"
        outlined        
      >
        <strong class="mr-1">Situação:</strong>
        <span>{{ order.status.label }}</span>
      </v-chip>
    </h4>
  </section>
</template>

<script>
  export default {
    name: 'OrderDetailHeader',
    props: {
      order: {
        type: Object,
        required: true
      }
    }
  };
</script>

<style lang="scss" scoped>
.status-area {
  display: flex;
  align-content: center;
  align-items: center;
  border-bottom: solid 1px #e5e5e5;
  text-align: center;
  justify-content: center;
  padding: 20px 0px;
  h4 {
    text-transform: uppercase;
    flex: 1;    
    span {
      font-size: 15px;
      font-weight: 400;
      color: #212121 !important;
    }
    strong {
      font-size: initial;
      color: #212121 !important;
      font-weight: 500;
    }
  }
}
</style>